import React from 'react';
import { Form, Formik } from 'formik';
import { TextField } from '../../components/Form';
import TextArea from '../../components/Form/TextArea';
import { MdOutlineEmail } from 'react-icons/md';
import ContactBannerImg from '../../assets/images/contact_banner.svg';
import { FaFacebookSquare, FaLinkedin, FaTwitterSquare } from 'react-icons/fa';
import * as Yup from 'yup';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Contact() {
    const { t } = useTranslation();
    return (
        <div>
            <div
                className={
                    'padding flex flex min-h-[300px] flex-col items-center justify-center border-b-8 border-SM-yellow bg-cover bg-center'
                }
                style={{
                    backgroundImage: `url(${ContactBannerImg})`,
                }}>
                <h4 className={'text-center uppercase text-SM-yellow'}>
                    {t('translation:CONTACT_US.DO_YOU_HAVE_QUESTIONS')}
                </h4>
                <h1 className={'mb-3 text-center '}>{t('translation:CONTACT_US.WRITE_US')}</h1>
                <p className={'w-72 text-center'}>
                    {t('translation:CONTACT_US.WE_WILL_ANSWER_AS_FAST')}
                </p>
            </div>

            <div className={'margin my-10'}>
                <div className="mb-4 rounded bg-red-100 p-4 text-center text-red-700 font-medium">
                    {t('contactForm.disabled', 'Formularz kontaktowy został wyłączony. Skontaktuj się z nami przez social media.')}
                </div>
                <Formik
                    initialValues={{
                        title: '',
                        email: '',
                        content: '',
                    }}
                    validationSchema={Yup.object().shape({
                        title: Yup.string()
                            .min(5, `${t('translation:ERRORS.WEB_VALIDATION.5')} 5`)
                            .max(256, `${t('translation:ERRORS.WEB_VALIDATION.6')} 256`)
                            .required(t('translation:ERRORS.WEB_VALIDATION.0') as string),
                        email: Yup.string()
                            .email(t('translation:ERRORS.WEB_VALIDATION.4') as string)
                            .required(t('translation:ERRORS.WEB_VALIDATION.0') as string),
                        description: Yup.string()
                            .min(10, `${t('translation:ERRORS.WEB_VALIDATION.5')} 10`)
                            .max(512, `${t('translation:ERRORS.WEB_VALIDATION.6')} 512`)
                            .required(t('translation:ERRORS.WEB_VALIDATION.0') as string),
                    })}
                    onSubmit={() => {
                        null;
                    }}>
                    {(fProps) => (
                        <Form
                            className={
                                'ml-auto mr-auto mb-10 flex w-full flex-col gap-3 p-4 shadow-xl sm:p-10 md:w-2/3'
                            }>
                            <h2 className={'mb-2 text-center'}>
                                {t('translation:CONTACT_US.LEAVE_US_A_MESSAGE')}
                            </h2>
                            <TextField
                                label={t('translation:CONTACT_US.MESSAGE_TITLE') as string}
                                name={'title'}
                                type={'text'}
                                formik={fProps}
                                placeholder={t('translation:CONTACT_US.TITLE') as string}
                            />

                            <TextField
                                label={t('translation:CONTACT_US.EMAIL') as string}
                                name={'email'}
                                type={'text'}
                                formik={fProps}
                                placeholder={'name@example.com'}
                            />
                            <TextArea
                                label={t('translation:CONTACT_US.MESSAGE') as string}
                                name={'description'}
                                formik={fProps}
                                placeholder={t('translation:CONTACT_US.YOUR_MESSAGE') as string}
                            />
                            <button disabled={true}
                                type={'submit'}
                                className={'btn-filled bg-SM-yellow text-white ring-SM-yellow/50 opacity-50 cursor-not-allowed'}>
                                {t('translation:CONTACT_US.SEND')}
                            </button>
                            <small>
                                <Trans
                                    i18nKey={'translation:CONTACT_US.GDPR_DISCLAIMER'}
                                    components={{
                                        GDPRTeam: (
                                            <Link
                                                to={'/statute/administrator'}
                                                className={'link'}
                                            />
                                        ),
                                        privacy: (
                                            <Link to={'/statute/privacy'} className={'link'} />
                                        ),
                                    }}
                                />
                            </small>
                        </Form>
                    )}
                </Formik>
                <div
                    className={'ml-auto mr-auto flex w-full flex-col gap-3 p-5 shadow-xl md:w-2/3'}>
                    <h2 className={'text-center'}>
                        {t('translation:CONTACT_US.YOU_WILL_FIND_US_HERE')}
                    </h2>
                    <div className={'flex justify-center gap-5 text-4xl'}>
                        {/* <a
                            rel={'noreferrer'}
                            target={'_blank'}
                            href={'mailto:contact@sprawnemiasto.pl'}
                            className={'transition-all hover:text-SM-yellow'}>
                            <MdOutlineEmail />
                        </a> */}
                        <a
                            rel={'noreferrer'}
                            target={'_blank'}
                            href={'https://www.facebook.com/sprawnemiaso'}
                            className={'transition-all hover:text-SM-yellow'}>
                            <FaFacebookSquare />
                        </a>
                        <a
                            rel={'noreferrer'}
                            target={'_blank'}
                            href={'https://pl.linkedin.com/company/sprawne-miasto'}
                            className={'transition-all hover:text-SM-yellow'}>
                            <FaLinkedin />
                        </a>
                        <a
                            rel={'noreferrer'}
                            target={'_blank'}
                            href={'https://twitter.com/SMiasto'}
                            className={'transition-all hover:text-SM-yellow'}>
                            <FaTwitterSquare />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
